import { useEffect, useState } from "react";
import axiosInstance from "../axios/axiosInstance";

export enum WarningType {
  Warning = "WARNING",
  Informational = "INFORMATIONAL",
}

export interface AnnouncementsData {
  id: string;
  type: WarningType;
  title: string;
  text: string;
}

export const useAnnouncements = () => {
  const [announcements, setAnnouncements] = useState<AnnouncementsData[] | []>(
    []
  );
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const fetchData = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await axiosInstance.get<AnnouncementsData[]>(
        "/v1/location/announcements"
      );

      setAnnouncements(response.data);
    } catch (err) {
      console.error("Błąd podczas pobierania danych:", err);
      setError("Wystąpił błąd podczas pobierania danych");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();

    const intervalId = setInterval(fetchData, 60000);
    console.log("intervalId", intervalId);

    return () => clearInterval(intervalId);
  }, []);

  const refetch = () => {
    fetchData();
  };

  return { announcements, loading, error, refetch };
};
